import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome, faLayerGroup, faPlay, faScrewdriverWrench, faGear } from "@fortawesome/free-solid-svg-icons";

const NavBarBottom = ({ isNavOpen, toggleNav }) => {
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(path);

    if (isNavOpen && window.innerWidth <= 580) {
      toggleNav();
    }
  };

  return (
    <footer className='navbar-bottom'>
      <div className='navbar-bottom-container'>
        <div onClick={() => handleNavigate('/')}>
          <FontAwesomeIcon icon={faHome} />
        </div>
      </div>
      <div className='navbar-bottom-container'>
        <div onClick={() => handleNavigate('/plans')}>
          <FontAwesomeIcon icon={faLayerGroup} />
        </div>
      </div>
      <div className='navbar-bottom-container'>
        <div onClick={() => handleNavigate('/demo')}>
          <FontAwesomeIcon icon={faPlay} />
        </div>
      </div>
      <div className='navbar-bottom-container'>
        <div onClick={() => handleNavigate('/setup')}>
          <FontAwesomeIcon icon={faScrewdriverWrench} />
        </div>
      </div>
      <div className='navbar-bottom-container'>
        <div onClick={() => handleNavigate('/start')}>
          <FontAwesomeIcon icon={faGear} />
        </div>
      </div>
    </footer>
  );
};

export default NavBarBottom;
